var PLACEMENT = /* @__PURE__ */ ((PLACEMENT2) => {
  PLACEMENT2["T"] = "t";
  PLACEMENT2["TL"] = "tl";
  PLACEMENT2["TR"] = "tr";
  PLACEMENT2["B"] = "b";
  PLACEMENT2["BL"] = "bl";
  PLACEMENT2["BR"] = "br";
  PLACEMENT2["L"] = "l";
  PLACEMENT2["LT"] = "lt";
  PLACEMENT2["LB"] = "lb";
  PLACEMENT2["R"] = "r";
  PLACEMENT2["RT"] = "rt";
  PLACEMENT2["RB"] = "rb";
  return PLACEMENT2;
})(PLACEMENT || {});
var EmitType = /* @__PURE__ */ ((EmitType2) => {
  EmitType2["HOVER"] = "hover";
  EmitType2["CLICK"] = "click";
  return EmitType2;
})(EmitType || {});
export {
  EmitType,
  PLACEMENT
};
